import { Grid } from '@mui/material';
import StyledDataGrid from '../../Components/StyledGrid';
import { ApiService } from '../../utils/ApiService';
import { useEffect, useMemo, useState } from 'react';
import { CustomLoadingOverlay } from '../../Components/CustomOverlay';
import { PageHeading } from '../../Components/Common/PageHeading';
import { Box, TextField, Button, Link } from '@mui/material';
import { CSVLink } from 'react-csv';
import UsageStatsDetails from './UsageStatsDetails';
// import PackageStatsDetails from './PackageStatsDetails';
import PkgStatsDetailsDialog from './PkgStatsDetailsDialog';

export const UsageStats = () => {

    const [usageStats, setUsageStats] = useState({ data: [], isLoading: true, error: null });
    const [searchTerm, setSearchTerm] = useState('');
    const [csvData, setCSVData] = useState([]);
    const [detailsInfo, setDetailsInfo] = useState({ open: false, data: null, type: null });

    const handleCellClick = async (cellData, rowData) => {
        const isUsernameClick = cellData.field === 'col1';
        const isPackageClick = cellData.field === 'col2';

        if (isUsernameClick) {
            const payload = {
                user_name: rowData.col1,
                pack_name: rowData.col2
            };

            setDetailsInfo({
                open: true,
                data: payload,
                type: 'user'
            });

            try {
                const response = await ApiService('get_user_stats', 'GET', payload);
                console.log('Username clicked, API response:', response);

                if (response?.body?.data) {
                    const userData = response.body.data;

                    setDetailsInfo({
                        open: true,
                        type: 'user',
                        data: {
                        usage_records: userData.records.map(r => ({
                            ...r,
                            accessed_date: r.accessed_date,
                            number_of_hits: r.number_of_hits,
                            user_name: r.user_name,
                            pack_name: r.pack_name,
                        })),
                        },
                    });
                    }

            } catch (error) {
                console.error('Error calling get_user_stats endpoint:', error);
                setDetailsInfo({
                    open: true,
                    data: { error: 'Failed to load user details' },
                    type: 'user'
                });
            }
        } else if (isPackageClick) {
            const payload = {
                pack_name: rowData.col2
            };

            setDetailsInfo({
                open: true,
                data: payload,
                type: 'package'
            });

            try {
                const response = await ApiService('get_package_stats', 'GET', payload);
                console.log('Package clicked, API response:', response);

                if (response && response.body && response.body.data) {
                    setDetailsInfo({
                        open: true,
                        data: response.body.data,
                        type: 'package'
                    });
                }
            } catch (error) {
                console.error('Error calling get_package_stats endpoint:', error);
                setDetailsInfo({
                    open: true,
                    data: { error: 'Failed to load package details' },
                    type: 'package'
                });
            }
        }
    };

    const handleDetailsClose = () => {
        setDetailsInfo({ open: false, data: null, type: null });
    };

    const renderClickableCell = (params) => {
        return (
            <Link
                component="button"
                variant="body2"
                onClick={(e) => {
                    e.stopPropagation();
                    handleCellClick(
                        { field: params.field, value: params.value },
                        params.row
                    );
                }}
                sx={{
                    textDecoration: 'none',
                    color: 'primary.main',
                    cursor: 'pointer',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                    border: 'none',
                    background: 'none',
                    padding: 0,
                    font: 'inherit',
                    textAlign: 'left',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {params.value}
            </Link>
        );
    };

    const columns = [
        {
            field: 'col1',
            headerName: 'Username',
            flex: 0.6,
            renderCell: renderClickableCell
        },
        {
            field: 'col2',
            headerName: 'Package name',
            flex: 1,
            renderCell: renderClickableCell
        },
        {
            field: 'col3',
            headerName: 'Count',
            flex: 0.5
        }
    ];

    useEffect(() => {
        setUsageStats({ ...usageStats, isLoading: true })
        ApiService('usage_stats', 'GET').
            then(response => setUsageStats({ ...usageStats, data: response.body.data, isLoading: false }))
            .catch(error => setUsageStats({ ...usageStats, error, isLoading: false }));
    }, []);

    useEffect(() => {
        const transformedData = usageStats.data.map(item => {
            const [pack_name, module_name] = item.pack_name.split('.');
            return {
                ...item,
                pack_name,
                module_name
            };
        });
        setCSVData(transformedData);

    }, [usageStats]);

    const rows = useMemo(() => {
        if (!usageStats.data || usageStats.data.length === 0) return [];

        return usageStats.data
            .filter(stats => {
                const searchValue = searchTerm.toLowerCase();
                return (
                    stats.user_name.toLowerCase().includes(searchValue) ||
                    stats.pack_name.toLowerCase().includes(searchValue)
                );
            })
            .map((stats, i) => ({
                id: i + 1,
                col1: stats.user_name,
                col2: stats.pack_name,
                col3: stats.count,
            }));
    }, [usageStats, searchTerm]);

    const headers = [
        { label: 'Username', key: 'user_name' },
        { label: 'Package name', key: 'pack_name' },
        { label: 'Module name', key: 'module_name' },
        { label: 'Count', key: 'count' },
    ];

    return (
        <Grid sx={{ height: '45vw', width: '100%' }}>
            {detailsInfo.open && (
            <PkgStatsDetailsDialog
                detailsInfo={detailsInfo}
                handleClose={handleDetailsClose}
            />
            )}

            {/* {detailsInfo.open && detailsInfo.type === 'package' && (
                <PkgStatsDetailsDialog
                    detailsInfo={detailsInfo}
                    handleClose={handleDetailsClose}
                />
            )} */}
            <Box display="flex" alignItems="center" style={{ marginBottom: '10px' }}>
                <PageHeading variant="h3" textAlign="left" name="Usage Stats" />
                <Button variant="contained" tabIndex={-1} style={{ width: "9rem" }}>
                    <CSVLink data={csvData} headers={headers} filename="User_stats_export.csv"
                        style={{ color: "white", textDecoration: "none", display: 'inline-block' }}>
                        Export CSV
                    </CSVLink>
                </Button>
                <TextField
                    variant="outlined"
                    placeholder="Search..."
                    size="small"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    style={{ width: "20rem", marginLeft: '20px' }}
                />
            </Box>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: { pageSize: 10, page: 0 },
                    },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
                rowHeight={40}
                autoHeight={true}
                disableRowSelectionOnClick={false}
                loading={usageStats.isLoading}
                slots={{
                    loadingOverlay: CustomLoadingOverlay
                }}
                localeText={{
                    noRowsLabel: "No Stats found"
                }}
            />
            <div>
                <br></br>
                <br></br>
                <br></br>
            </div>
        </Grid>
    );
}
